import React, { useRef, useState } from 'react';
import styled from 'styled-components';

const UploaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const UploadButton = styled.button`
  background-color: #4a90e2;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #357abd;
  }
`;

const PreviewContainer = styled.div`
  margin-top: 20px;
  max-width: 400px;
  max-height: 600px;
  overflow: hidden;
  
  img {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const Instructions = styled.p`
  margin-bottom: 20px;
  color: #555;
  text-align: center;
`;

const ImageUploader = ({ onImageSelected }) => {
  const [preview, setPreview] = useState(null);
  const fileInputRef = useRef(null);
  
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = (e) => {
      const imageData = e.target.result;
      setPreview(imageData);
      onImageSelected(imageData);
    };
    reader.readAsDataURL(file);
  };
  
  return (
    <UploaderContainer>
      <h2>Upload Your Photo</h2>
      <Instructions>
        For the most accurate measurements, please upload a full-body photo where you're standing straight with arms slightly away from your body.
      </Instructions>
      
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileSelect}
        accept="image/*"
        style={{ display: 'none' }}
      />
      
      <UploadButton onClick={() => fileInputRef.current.click()}>
        Choose Image
      </UploadButton>
      
      {preview && (
        <PreviewContainer>
          <img src={preview} alt="Preview" />
        </PreviewContainer>
      )}
    </UploaderContainer>
  );
};

export default ImageUploader;